<div class="dashboard-shell">
  <div class="workspace">
    <section class="chat-panel">
      <header class="panel-header">Welcome to BrijjBuddy Ai bot.</header>
      <div class="chat-scroll" #chatScroll>
        <div *ngFor="let m of chatMessages" class="chat-row" [class.is-user]="m.sender==='user'">
          <!-- Bot message -->
          <div *ngIf="m.sender === 'bot'" class="bot-content">
            <img src="/assets/icons/bot.svg" alt="Bot Logo" class="bot-logo">
            <div class="bot-messages">
              <div class="bubble" *ngIf="m.text">{{ m.text }}</div>

              <!-- Single Quality Suggestion with Yes/No buttons -->
              <div class="quality-suggestion-actions" *ngIf="m.qualitySuggestion">
                <div class="quality-action-text">
                  Would you like to change the quality to "<strong>{{ m.qualitySuggestion.suggestedQuality }}</strong>"?
                </div>
                <div class="action-buttons">
                  <button class="btn-yes"
                    (click)="acceptQualitySuggestion(m, m.qualitySuggestion.targetMessage, m.qualitySuggestion.suggestedQuality)">
                    Yes
                  </button>
                  <button class="btn-no" (click)="declineQualitySuggestion(m)">
                    No
                  </button>
                </div>
              </div>

              <!-- Multiple Quality Suggestions with individual buttons -->
              <div class="quality-suggestions-actions" *ngIf="m.qualitySuggestions">
                <div class="quality-action-text">
                  Select a quality option:
                </div>
                <div class="quality-options-list">
                  <button class="btn-quality-option" *ngFor="let quality of m.qualitySuggestions.suggestedQualities"
                    (click)="acceptSpecificQuality(m, m.qualitySuggestions.targetMessage, quality)">
                    {{ quality }}
                  </button>
                </div>
                <button class="btn-no-small" (click)="declineQualitySuggestion(m)">
                  Skip
                </button>
              </div>

              <img *ngIf="m.image" class="chat-image" [src]="m.image" alt="Captured frame" />

              <div *ngIf="m.product" class="product-card">
                <div class="product-header">
                  <span class="title">Product Information</span>
                  <button class="edit-btn" (click)="toggleEdit(m)" aria-label="Edit">
                    <img src="/assets/icons/pencil.svg" alt="Edit" />
                  </button>
                </div>

                <!-- Display Mode -->
                <div class="product-body" *ngIf="!m.editing">
                  <div class="row" *ngIf="m.product.department">
                    <span class="label">Department:</span>
                    <span class="val">{{ m.product.department }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.category">
                    <span class="label">Category:</span>
                    <span class="val">{{ m.product.category }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.subcategory">
                    <span class="label">Subcategory:</span>
                    <span class="val">{{ m.product.subcategory }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.qualityDescr">
                    <span class="label">Quality Description:</span>
                    <span class="val">{{ m.product.qualityDescr }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.size">
                    <span class="label">Size:</span>
                    <span class="val">{{ m.product.size }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.brand">
                    <span class="label">Brand:</span>
                    <span class="val">{{ m.product.brand }}</span>
                  </div>
                  <div class="row" *ngIf="m.product.price">
                    <span class="label">Price:</span>
                    <span class="val">${{ m.product.price | number:'1.2-2' }}</span>
                  </div>
                  <div class="row">
                    <span class="label">Quantity:</span>
                    <span class="val">{{ quantity }}</span>
                  </div>
                  <div class="row">
                    <span class="label">Pieces:</span>
                    <span class="val">{{ pieces }}</span>
                  </div>
                  <div class="row" *ngIf="getSelectedLabelName(m)">
                    <span class="label">Selected Label:</span>
                    <span class="val">{{ getSelectedLabelName(m) }}</span>
                  </div>
                </div>

                <!-- Edit Mode with Searchable Dropdowns -->
                <div class="product-edit" *ngIf="m.editing">
                  <!-- Department Searchable Dropdown -->
                  <div class="form-group">
                    <label class="form-label">Department:</label>
                    <div class="searchable-dropdown" [class.open]="m.departmentDropdownOpen">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search department..."
                          [value]="getDepartmentInputValue(m)" (input)="onDepartmentSearchInput(m, $event)"
                          (focus)="openDepartmentDropdown(m)" (blur)="closeDepartmentDropdown(m)"
                          (click)="openDepartmentDropdown(m)">
                        <span class="dropdown-arrow" (click)="toggleDepartmentDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.departmentDropdownOpen">
                        <div class="dropdown-option" *ngFor="let dept of getFilteredDepartments(m)"
                          (mousedown)="selectDepartment(m, dept)" [class.selected]="isDepartmentSelected(m, dept)">
                          {{dept.label}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredDepartments(m).length === 0">
                          No departments found
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Category Searchable Dropdown -->
                  <div class="form-group">
                    <label class="form-label">Category:</label>
                    <div class="searchable-dropdown" [class.open]="m.categoryDropdownOpen"
                      [class.disabled]="!m.product.department">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search category..."
                          [value]="getCategoryInputValue(m)" (input)="onCategorySearchInput(m, $event)"
                          (focus)="openCategoryDropdown(m)" (blur)="closeCategoryDropdown(m)"
                          (click)="openCategoryDropdown(m)" [disabled]="!m.product.department">
                        <span class="dropdown-arrow" (click)="toggleCategoryDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.categoryDropdownOpen && m.product.department">
                        <div class="dropdown-option" *ngFor="let cat of getFilteredCategories(m)"
                          (mousedown)="selectCategory(m, cat)" [class.selected]="isCategorySelected(m, cat)">
                          {{cat.label}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredCategories(m).length === 0">
                          No categories found
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Subcategory -->
                  <div class="form-group" *ngIf="m.product.subcategory">
                    <label class="form-label">Subcategory:</label>
                    <input type="text" class="form-input" [value]="m.product.subcategory || ''"
                      (input)="onProductFieldInput(m, 'subcategory', $event)" placeholder="Enter subcategory" />
                  </div>

                  <!-- Quality Description Searchable Dropdown -->
                  <div class="form-group">
                    <label class="form-label">Quality Description:</label>
                    <div class="searchable-dropdown" [class.open]="m.qualityDropdownOpen">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search quality..."
                          [value]="getQualityInputValue(m)" (input)="onQualitySearchInput(m, $event)"
                          (focus)="openQualityDropdown(m)" (blur)="closeQualityDropdown(m)"
                          (click)="openQualityDropdown(m)">
                        <span class="dropdown-arrow" (click)="toggleQualityDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.qualityDropdownOpen">
                        <div class="dropdown-option" *ngFor="let quality of getFilteredQualities(m)"
                          (mousedown)="selectQuality(m, quality)" [class.selected]="isQualitySelected(m, quality)">
                          {{quality.label}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredQualities(m).length === 0">
                          No qualities found
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Size Searchable Dropdown -->
                  <div class="form-group" *ngIf="m.product.size">
                    <label class="form-label">Size:</label>
                    <div class="searchable-dropdown" [class.open]="m.sizeDropdownOpen">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search size..."
                          [value]="getSizeInputValue(m)" (input)="onSizeSearchInput(m, $event)"
                          (focus)="openSizeDropdown(m)" (blur)="closeSizeDropdown(m)" (click)="openSizeDropdown(m)">
                        <span class="dropdown-arrow" (click)="toggleSizeDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.sizeDropdownOpen">
                        <div class="dropdown-option" *ngFor="let size of getFilteredSizes(m)"
                          (mousedown)="selectSize(m, size)" [class.selected]="isSizeSelected(m, size)">
                          {{size.label}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredSizes(m).length === 0">
                          No sizes found
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Brand Searchable Dropdown -->
                  <div class="form-group" *ngIf="brands.length > 0">
                    <label class="form-label">Brand:</label>
                    <div class="searchable-dropdown" [class.open]="m.brandDropdownOpen">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search brand..."
                          [value]="getBrandInputValue(m)" (input)="onBrandSearchInput(m, $event)"
                          (focus)="openBrandDropdown(m)" (blur)="closeBrandDropdown(m)" (click)="openBrandDropdown(m)">
                        <span class="dropdown-arrow" (click)="toggleBrandDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.brandDropdownOpen">
                        <div class="dropdown-option" *ngFor="let brand of getFilteredBrands(m)"
                          (mousedown)="selectBrand(m, brand)" [class.selected]="isBrandSelected(m, brand)">
                          {{brand.label}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredBrands(m).length === 0">
                          No brands found
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Price -->
                  <div class="form-group">
                    <label class="form-label">Price:</label>
                    <input type="text" class="form-input price-input" [value]="m.product.price || ''"
                      (input)="onProductFieldInput(m, 'price', $event)" placeholder="Enter price (e.g., 19.99)" />
                  </div>

                  <!-- Quantity -->
                  <div class="form-group">
                    <label class="form-label">Quantity:</label>
                    <input type="number" class="form-input" [value]="quantity" (input)="onQuantityInput($event)"
                      placeholder="Enter quantity" min="1" />
                  </div>

                  <!-- Pieces -->
                  <div class="form-group">
                    <label class="form-label">Pieces:</label>
                    <input type="number" class="form-input" [value]="pieces" (input)="onPiecesInput($event)"
                      placeholder="Enter pieces" min="1" />
                  </div>

                  <!-- Labels Dropdown -->
                  <div class="form-group">
                    <label class="form-label">Label:</label>
                    <div class="searchable-dropdown" [class.open]="m.labelDropdownOpen">
                      <div class="dropdown-input">
                        <input type="text" class="search-input" placeholder="Search label..."
                          [value]="getLabelInputValue(m)" (input)="onLabelSearchInput(m, $event)"
                          (focus)="openLabelDropdown(m)" (blur)="closeLabelDropdown(m)" (click)="openLabelDropdown(m)">
                        <span class="dropdown-arrow" (click)="toggleLabelDropdown(m)">▼</span>
                      </div>
                      <div class="dropdown-options" *ngIf="m.labelDropdownOpen">
                        <div class="dropdown-option" *ngFor="let label of getFilteredLabels(m)"
                          (mousedown)="selectLabel(m, label)"
                          [class.selected]="ProductInfo.labelId === label.id">
                          {{label.name}}
                        </div>
                        <div class="no-options" *ngIf="getFilteredLabels(m).length === 0">
                          No labels found
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="edit-actions">
                    <button class="cancel" (click)="cancelEdit(m)">Cancel</button>
                    <button class="save" (click)="saveEdit(m)">Save</button>
                  </div>
                </div>

                <div class="product-footer">
                  <button class="approve" *ngIf="!m.approved" (click)="approveProduct(m)">Approve</button>
                  <span class="approved" *ngIf="m.approved">Approved</span>
                </div>
              </div>
            </div>
          </div>

          <!-- User message -->
          <div *ngIf="m.sender === 'user'" class="user-content">
            <div class="user-messages">
              <div class="bubble" *ngIf="m.text">{{ m.text }}</div>
              <img *ngIf="m.image" class="chat-image" [src]="m.image" alt="Captured frame" />
            </div>
            <img [src]="userImagePath" alt="User Avatar" class="user-avatar">
          </div>
        </div>
      </div>

      <!-- Quick-access questions, already filtered to this user's permissions -->
      <div class="chat-suggestions" *ngIf="suggestionChips.length">
        <button type="button" class="suggestion-chip" *ngFor="let chip of suggestionChips"
          (click)="useSuggestion(chip)" [title]="chip.label">
          {{ chip.label }}
        </button>
      </div>

      <div class="chat-input">
        <input type="text" placeholder="Ask a question, or try 'update department [name]'" [(ngModel)]="inputText"
          (keyup.enter)="send()" />
        <button class="mic-btn" (click)="micToggle()" [class.active]="isListening" aria-label="Speak">
          <img src="/assets/icons/mic.svg" alt="Mic" />
        </button>
        <button class="send-btn" (click)="send()" aria-label="Send">➤</button>
      </div>

      <!-- Command hints -->
      <div class="chat-commands-hint" *ngIf="chatMessages.length > 1">
        <small>💡 Commands: "update department [name]", "update category [name]", "update price [amount]", "update size
          [size]", "show departments"</small>
      </div>
    </section>

    <section class="camera-panel">
      <div class="video-wrap">
        <video #camera playsinline autoplay muted></video>
        <div class="grid-overlay" aria-hidden="true">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div class="permission-alert" *ngIf="permissionMessage">
        <span>{{ permissionMessage }}</span>
        <button class="retry" (click)="handleStartClick()">Try again</button>
      </div>

      <div class="controls">
        <button class="control-button start" (click)="handleStartClick()" [disabled]="isProcessing || isRecording"
          [class.busy]="isProcessing || isRecording">
          <span class="btn-spinner" *ngIf="isProcessing" aria-hidden="true"></span>
          <span class="rec-dot" *ngIf="!isProcessing && isRecording" aria-hidden="true"></span>
          <span>{{ isProcessing ? 'Starting...' : (isRecording ? 'Recording' : 'Start') }}</span>
        </button>

        <button class="control-button pause" (click)="togglePause()" [disabled]="!isRecording">
          {{ isPaused ? 'Resume' : 'Pause' }}
        </button>

        <button class="control-button generate" (click)="handleGenerateClick()"
          [disabled]="isProcessing || (!isRecording && recordedChunks.length === 0)" [class.busy]="isUploading">
          <span class="btn-spinner" *ngIf="isUploading" aria-hidden="true"></span>
          <span>{{ isUploading ? 'Uploading...' : 'Generate' }}</span>
        </button>
      </div>
    </section>
  </div>
</div>